import { Injectable } from '@angular/core';
import { DbContext, DbTable } from '../data/dbcontext.service';
import { HttpClient } from '@angular/common/http';
import { WeatherReading, WeatherSetup } from '../../models/weather-readings/weather-readings.models';
import { ActionType, ErrorType, ValidationResult } from '../../models/projects/validation.models';
import * as moment from 'moment';
import { LockedDayService } from '../locked-day/locked-day.service';
import { DailyLogService } from '../daily-log/daily-log.service';
import { DateService } from '../date/date.service';
import { AppConfig } from '../../app/app.config';
import { VesselService } from '../vessel/vessel.service';

@Injectable()
export class WeatherLogValidationService {
  config = AppConfig.settings;
  private readonly weatherLogDataTable: DbTable;
  private readonly weatherSetupTable: DbTable;

  constructor(
    private http: HttpClient,
    private dbContext: DbContext,
    private dailyLogService: DailyLogService,
    private lockedDayService: LockedDayService,
    private dateService: DateService,
    private vesselService: VesselService
  ) {
    this.weatherLogDataTable = this.dbContext.tables.find(t => t.name === 'WeatherLogData');
    this.weatherSetupTable = this.dbContext.tables.find(t => t.name === 'WeatherSetup');
  }

  async validateWeatherLog(logs: WeatherReading[]): Promise<ValidationResult> {
    let validationResult = new ValidationResult();

    if (await this.vesselService.isCurrentVesselNonJacking()) {
      return validationResult;
    }

    for (let i = 0; i < logs.length; i++) {
      validationResult = await this.validateReading(logs[i], validationResult);
    }

    return validationResult;
  }

  async validateReading(reading: WeatherReading, validationResult: ValidationResult) {
    const currentLocalTime = new Date();
    const newReadingTime = moment(reading.date).add(15, 'm').toDate();

    if (currentLocalTime > newReadingTime) {
      switch (reading.statusId) {
        case 1: {
          validationResult.addError(
            'A weather reading for \'' + reading.timeShow + '\' has not yet been recorded.',
            ErrorType.Error,
            ActionType.Weather);
          break;
        }
        case 2: {
          validationResult.addError(
            'A weather reading for \'' + reading.timeShow + '\' needs to be completed. Not all mandatory fields have been recorded.',
            ErrorType.Error,
            ActionType.Weather);
        }
          break;
      }
    }

    return validationResult;
  }
}



// WEBPACK FOOTER //
// ./src/services/weather-readings/weather-log-validation.service.ts